import aboutPayment from "components/About/Payment";

export default aboutPayment;



// WEBPACK FOOTER //
// ./src/containers/About/Payment/index.js